import { useToast } from "@chakra-ui/react"

import { useMutation } from "@tanstack/react-query"

import { useTRPC } from "lib/trpc"

export const useSendBugReport = () => {
  const trpc = useTRPC()
  const { mutate: sendBugReport } = useMutation(
    trpc.utils.sendSlackBugReport.mutationOptions(),
  )
  const toast = useToast()

  return ({
    what,
    error,
    details,
    onSuccess,
    onError,
  }: {
    what: string
    error?: string | null | undefined
    details?: { [key: string]: string | null | undefined }
    onSuccess?: () => void
    onError?: () => void
  }) => {
    let message = `*What?*\n${what}\n`

    if (details) {
      message += `\n${Object.entries(details)
        .map(([key, value]) => `_${key}_: ${value}`)
        .join("\n")}`
    }

    if (error) {
      message += `\n*Error* \`\`\`${error}\`\`\``
    }

    return sendBugReport(
      { message },
      {
        onSuccess: () => {
          toast({ status: "success", description: "Bug report sent" })
          onSuccess?.()
        },
        onError: () => {
          toast({ status: "error", description: "Failed to send bug report" })
          onError?.()
        },
      },
    )
  }
}
